/**
 * Générateur — Automatisme : factoriser une expression simple.
 * Attendu ID : 1231 | Niveau : 3ème | Domaine : Calcul littéral et algébrique
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 798).
 *
 * Les clés factoriser_* de gen_1230 (un fichier « distributivité », deux jeux
 * de clés, modèle 1213/1246, base du prof du 13/09) : items, distracteurs et
 * sacrifié sont ceux de gen_1230 ; les payloads portent déjà l'attendu 1231.
 */
import { genererParmi, CATEGORIES_FACTORISER } from './gen_1230';

export const CATEGORIES = CATEGORIES_FACTORISER;
const CLES = CATEGORIES_FACTORISER.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
